export const types = { // eslint-disable-line import/prefer-default-export
  cohort: 'COHORT',
  aggregate: 'AGGREGATE',
  event: 'EVENT',
  list: 'LIST',
  map: 'MAP',
  property: 'PROPERTY',
  status: 'STATUS',
  floorplan: 'FLOORPLAN',
  device: 'DEVICE',
  workflow: 'WORKFLOW',
  alarms: 'ALARMS',
};
